<div bdFxLayout="row wrap" class="ps-container">
    <div bdFxLayoutAlign="center center" class="ps-label {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}"
         *ngIf="label">
        {{label}}
    </div>
    <div class="input-container" bdFxFlex="1 1 100%">

        <button class="ps-value {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}"
                (click)="togglePanel()" [disabled]="disabled"
                #buttonElement
                [id]="id ? id : name"
                type="button"
                (keydown)="onKeyPressed($event)"
                (blur)="onBlur()">
            <span [ngClass]="model>-1 ? 'value' : 'placeholder'" [innerHTML]="model > -1 ? choices[model]?.label : placeholder"></span>
            <bd-fa-button [name]="'chevron-down'"></bd-fa-button>

            <ng-container *ngTemplateOutlet="!isIEMode ? panel: null"></ng-container>
        </button>

        <!--    for IE11 panel is displayed out of button tag-->
        <ng-container *ngTemplateOutlet="isIEMode ? panel: null"></ng-container>

        <ng-template #panel>
            <div class="panel-container" [ngClass]="{'is-expanded':isExpanded}" (mouseleave)="mouseLeave()"
                 (click)="closePanel(buttonElement); $event.stopPropagation();">
                <div class="panel-animation-visibility-controller">
                    <div class="panel" *ngIf="isExpanded" @open>
                        <ul>
                            <ng-container *ngFor="let choice of choices; let i = index">
                                <li (click)="onChoiceSelected(i)"
                                    [ngClass]="getChoiceItemClass(i)">
                                    <div class="label" [ngClass]="choice.labelClass" [innerHTML]="choice.label">{{choice.label}}</div>
                                </li>
                            </ng-container>

                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

</div>
